interface NoTaskCardProps {
  message?: string;
}

export function NoTaskCard({ message }: NoTaskCardProps) {
  return (
    <div className="mx-4">
      <div className="bg-card rounded-2xl p-6 shadow-sm text-center">
        <div className="text-6xl mb-4">🎉</div>
        <h2 className="text-[22px] leading-[28px] font-bold">
          Gerade keine Mission frei
        </h2>
        <p className="text-[15px] leading-[20px] text-muted-foreground mt-2">
          {message || 'Reiche eine neue Fotoidee ein oder schau gleich nochmal vorbei.'}
        </p>
      </div>
    </div>
  );
}
